import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  JustifyContent,
  Space,
} from '@gousto-internal/citrus-react'
import classnames from 'classnames'

import { MenuPreferencesButton } from 'routes/Menu/components/MenuPreferences/MenuPreferencesButton'
import { useAuth } from 'routes/Menu/domains/auth'

import { MenuDateRange } from '../MenuDateRange'
import { MenuDeliveryDate } from '../MenuDateRange/MenuDeliveryDate'
import { SearchButton } from '../Search/SearchButton/SearchButton'
import { BackButtonWrapper } from './BackButtonWrapper'

import css from './SubHeader.css'

type SubHeaderProps = {
  fromJoin?: boolean
}

export const SubHeader = ({ fromJoin = false }: SubHeaderProps) => {
  const { isAuthenticated } = useAuth()

  return (
    <div className={classnames(css[fromJoin ? 'subHeaderSimple' : 'subHeader'])}>
      <div className={css.subHeaderContent}>
        <div className={css.filter}>
          <Box alignItems={AlignItems.Center} display={Display.Flex}>
            {isAuthenticated ? (
              <Box
                display={Display.Flex}
                alignItems={AlignItems.Center}
                flexShrink={0}
                justifyContent={JustifyContent.Center}
                data-testid="deliveryDetailsBackButton-desktop"
              >
                <BackButtonWrapper variant="desktop" />
                <Space size={4} direction="horizontal" />
                <MenuDeliveryDate variant="desktop" />
              </Box>
            ) : (
              <Box flexShrink={0}>
                <MenuDateRange variant="desktop" />
              </Box>
            )}
          </Box>
          <Box paddingH={8} width="50%">
            <SearchButton />
          </Box>
          <div className={css.filterRight}>
            <div className={css.filterSection}>
              {isAuthenticated && <MenuPreferencesButton variant="desktop" />}
            </div>
          </div>
        </div>
      </div>
      <div className={css.mobile}>
        <Box
          alignItems={AlignItems.Center}
          bg={Color.White}
          display={Display.Flex}
          justifyContent={JustifyContent.SpaceBetween}
          paddingH={3}
          paddingV={2}
        >
          {isAuthenticated && (
            <Box
              display={Display.Flex}
              alignItems={AlignItems.Center}
              justifyContent={JustifyContent.Center}
              data-testid="deliveryDetailsBackButton-mobile"
            >
              <BackButtonWrapper variant="mobile" />
              <Space size={4} direction="horizontal" />
            </Box>
          )}
          <Box width="100%">
            <SearchButton />
          </Box>
          {isAuthenticated && <MenuPreferencesButton variant="mobile" />}
        </Box>
      </div>
    </div>
  )
}
